// lib/api.ts
//
// Un seul rôle : centraliser l'URL du backend Render en un seul endroit.
// Chaque fichier (hook, écran) importe cette variable et fait son propre
// fetch() avec sa propre route et sa propre logique — rien d'autre n'est
// géré ici.
//
// Pourquoi : si un jour le backend change d'adresse (nouveau service
// Render, nouveau domaine, etc.), on modifie uniquement cette ligne —
// aucun autre fichier du projet n'a besoin d'être touché.

export const API_BASE_URL = 'https://eueke282zksk1zki18susjdksisk18sj.onrender.com';
